import { ErrorHandler, Injectable, Injector } from '@angular/core'
import { environment } from '../../environments/environment'
import { extractErrorMessage } from '../utils/error-util'
import { ErrorPopupService } from './error-popup.service'
import { ModalController } from '@ionic/angular'

@Injectable()
export class ErrorHandlerService implements ErrorHandler {
  constructor(
    private readonly injector: Injector,
    private readonly errorPopup: ErrorPopupService
  ) {}

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  async handleError(error: any): Promise<void> {
    if (!environment.applicationReady) {
      const message = extractErrorMessage(error)?.replace(/\n/g, '<br/>')

      // Lazy-load ModalController to avoid circular DI issues
      const modalCtrl = this.injector.get(ModalController)
      const modalProps = this.errorPopup.getErrorModal(message)

      const modal = await modalCtrl.create(modalProps)
      await modal.present()
    } else {
      console.error(error)
    }
  }
}
